import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Result } from 'antd';
import { setHeader, setRoutes } from 'src/core/ui/shell';

const NotFoundPage: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  setHeader(t('NotFound'));
  setRoutes([]);
  return (
    <Result
      status="404"
      title="404"
      subTitle={t('HomeError')}
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          {t('BackHome')}
        </Button>
      }
    />
  );
};

export default NotFoundPage;
